import { Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule } from 'lucide-angular';
import { PackLimitationsService } from '../../services/pack-limitations.service';
import { ButtonModule } from 'primeng/button';
import { LimitedFeatures } from '../../models/pack.models';

@Component({
  selector: 'app-trip-limit-indicator',
  imports: [
    CommonModule,
    ProgressBarModule,
    TagModule,
    TooltipModule,
    TranslocoModule,
    LucideAngularModule,
    ButtonModule,
  ],
  templateUrl: './trip-limit-indicator.component.html',
})
export class TripLimitIndicatorComponent {
  private packLimitationService = inject(PackLimitationsService);
  tripUsed: number = 0;
  tripLimit: number = 0;
  constructor() {
    effect(() => {
      this.tripUsed = this.packLimitationService.currentNumberOfTrips();
      this.tripLimit = this.packLimitationService.tripLimit();
    });
  }
  get progressPercentage(): number {
    if (this.tripLimit === 0) return 0;
    return Math.round((this.tripUsed / this.tripLimit) * 100);
  }
  get textColor() {
    if (this.progressPercentage > 90) return 'text-error-700';
    if (this.progressPercentage > 60) return 'text-warning-600';
    return 'text-validation-600';
  }
  openContactModal() {
    this.packLimitationService.openModal(LimitedFeatures.Trip);
  }
}
